export const getUrlParamZone = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const nameZone = urlParams.get("zone");
  switch (nameZone) {
    case "fontana":
      return "Banqueta_fontana_MT_G_terreno_0";
    case "sacramento":
      return "Banqueta_sacramento_MT_G_terreno_0";
    case "arcadia":
      return "Banqueta_arcadia_MT_G_terreno_0";
    case "rinconada":
      return "Banqueta_rinconada_MT_G_terreno_0";
    case "capri":
      return "Banqueta_capri_MT_G_terreno_0";
    case "creta":
      return "Banqueta_Creta_MT_G_terreno_0";
    case "rodas":
      return "Banqueta_rodas_MT_G_terreno_0";
    case "vilansa":
      return "Banqueta_vilansa_MT_G_terreno_0";
    case "viena":
      return "Banqueta_parqueViena_MT_G_terreno_0";
    case "berna":
      return "Banqueta_parqueBerna_MT_G_terreno_0";
    case "sofia":
      return "Banqueta_sofia_MT_G_terreno_0";
    case "palermo":
      return "Banqueta_palermo_MT_G_terreno_0";
    case "anturio":
      return "Banqueta_anturio_MT_G_terreno_0";
    case "lucerna":
      return "Banqueta_lucerna";
    case "cantera":
      return "Banqueta_lacantera";
    case "balcanes":
      return "Banqueta_balcanes";
    case "antalya":
      return "Banqueta_antalya";
    case "niza":
      return "Banqueta_niza";
    case "trento":
      return "Banqueta_trento";
    case "verona":
      return "Banqueta_verona";
    case "sorrento":
      return "Banqueta_sorrento";
    case "bali":
      return "Banqueta_bali_MT_G_terreno_0";
    case "zante":
      return "Banqueta_zante";
    case "ferrara":
      return "Banqueta_Ferrara";
    case "sienna":
      return "Banqueta_Siena";
    default:
      return null;
  }
};
